import React from 'react';
import { motion } from 'framer-motion';
export function ProcessSection() {
  const steps = [{
    num: '01',
    title: 'Listen',
    desc: 'Understand the concern, context and desired outcome.',
    timeframe: 'Week 1',
    color: 'bg-brand-magenta'
  }, {
    num: '02',
    title: 'Diagnose',
    desc: 'Identify whether the issue is interpersonal, systemic, cultural or leadership-related.',
    timeframe: 'Week 1-2',
    color: 'bg-brand-plum'
  }, {
    num: '03',
    title: 'Facilitate',
    desc: 'Create safe conversations and practical pathways for resolution.',
    timeframe: 'Week 2-4',
    color: 'bg-brand-deep-purple'
  }, {
    num: '04',
    title: 'Equip',
    desc: 'Strengthen leadership capability, communication and conflict confidence.',
    timeframe: 'Week 4-8',
    color: 'bg-brand-teal'
  }, {
    num: '05',
    title: 'Report & Improve',
    desc: 'Provide de-identified insights, themes and recommendations where appropriate.',
    timeframe: 'Week 8+',
    color: 'bg-brand-orange'
  }];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-399">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-400">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-401">
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-brand-charcoal" data-id="element-402">
            A clear, confidential process — from first contact to lasting
            resolution.
          </h2>
          <p className="text-brand-charcoal/80 leading-relaxed font-normal text-lg" data-id="element-403">
            Engagements are tailored to your needs. Some organisations start
            with a single facilitated conversation. Others need ongoing systemic
            support over 3-6 months.
          </p>
        </motion.div>

        <div className="relative" data-id="element-404">
          {/* Gradient Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-1 bg-gradient-to-r from-brand-magenta via-brand-teal to-brand-orange rounded-full z-0" data-id="element-405"></div>

          <div className="grid lg:grid-cols-5 gap-8 relative z-10" data-id="element-406">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center group" data-id="element-407">
                <div className={`w-24 h-24 rounded-full bg-white border-4 border-gray-200 flex items-center justify-center mb-6 relative transition-all duration-500 group-hover:border-brand-teal group-hover:scale-110 shadow-lg`} data-id="element-408">
                  <div className={`absolute inset-2 rounded-full ${step.color} opacity-20 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-409"></div>
                  <span className="font-serif text-2xl text-brand-charcoal relative z-10 font-bold" data-id="element-410">
                    {step.num}
                  </span>
                </div>

                <h3 className="text-xl font-serif mb-2 text-brand-charcoal group-hover:text-brand-teal transition-colors" data-id="element-411">
                  {step.title}
                </h3>
                <p className="text-xs text-brand-teal font-semibold mb-4 uppercase tracking-wider" data-id="element-412">
                  {step.timeframe}
                </p>
                <p className="text-[15px] text-brand-charcoal/80 leading-relaxed font-normal" data-id="element-413">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 bg-brand-off-white p-8 rounded-sm border-l-4 border-brand-teal" data-id="element-414">
          <p className="text-brand-charcoal/80 leading-relaxed font-normal text-lg mb-4" data-id="element-415">
            <strong className="text-brand-charcoal" data-id="element-416">
              What happens after you contact us:
            </strong>{' '}
            Initial call within 24 hours → Confidential consultation (30-60 min)
            → Tailored proposal → Engagement begins. If EquipMe is not the right
            fit, we will tell you in the first consultation — no obligation.
          </p>
          <p className="text-brand-charcoal font-semibold text-lg" data-id="element-417">
            Every engagement starts with a single conversation. No commitment
            required.
          </p>
        </motion.div>
      </div>
    </section>;
}